import { pickElementFromSet } from './pick-element-from-set';
export const deleteActiveInputConnectionToAudioParam = (activeInputs, source, output) => {
    return pickElementFromSet(activeInputs, (activeInputConnection) => activeInputConnection[0] === source && activeInputConnection[1] === output);
};
//# sourceMappingURL=delete-active-input-connection-to-audio-param.js.map